// settings page strings. Keys are read as $t('settings.<key>').
export default {
  en: {
    title: 'Settings',
    subtitle: 'Shipping geography: ship districts, new wards, districts and wards.',
    tabs: {
      shipdis: 'ShipDis',
      newward: 'New Ward',
      district: 'District',
      ward: 'Ward',
    },
    newButton: '+ New',
    showInactive: 'Show inactive',
    active: 'Active',
    inactive: 'Inactive',
    edit: 'Edit',
    modalNew: 'New {label}',
    modalEdit: 'Edit {label}',
    close: 'Close',
    cancel: 'Cancel',
    save: 'Save',
    saving: 'Saving…',
    saveFailed: 'Save failed.',
    isActive: 'Is active',
    headers: {
      id: 'ID',
      name: 'Name',
      noAccent: 'No Accent',
      noAbbrev: 'No Abbrev',
      newWard: 'New Ward',
      district: 'District',
      priceId: 'Price ID',
      group: 'Group',
      shipDis: 'ShipDis',
      price: 'Price',
      active: 'Active',
      actions: 'Actions',
    },
    fields: {
      name: 'Name',
      nameNoAccent: 'Name (no accent)',
      nameNoAbbrev: 'Name (no abbrev)',
      newWard: 'New Ward',
      districtHint: 'District: {district} (set on the New Ward tab)',
      editNewWard: 'Edit New Ward (District / ShipDis)',
      editNewWardTitle: 'District and ShipDis belong to the New Ward — open this New Ward to change them',
      districtPriceId: 'District Price ID',
      group: 'Group',
      shipDis: 'ShipDis',
      mapDistrict: 'Map District',
      price: 'Price',
      subDistricts: 'Has sub districts',
      wardList: 'Ward List',
      shipLocCount: 'Ship Loc Count',
      district: 'District',
    },
  },
  vi: {
    title: 'Cài đặt',
    subtitle: 'Địa lý giao hàng: khu vực ship, phường mới, quận và phường.',
    tabs: {
      shipdis: 'ShipDis',
      newward: 'Phường mới',
      district: 'Quận',
      ward: 'Phường',
    },
    newButton: '+ Thêm',
    showInactive: 'Hiện mục ngưng dùng',
    active: 'Đang dùng',
    inactive: 'Ngưng dùng',
    edit: 'Sửa',
    modalNew: 'Thêm {label}',
    modalEdit: 'Sửa {label}',
    close: 'Đóng',
    cancel: 'Huỷ',
    save: 'Lưu',
    saving: 'Đang lưu…',
    saveFailed: 'Lưu không thành công.',
    isActive: 'Đang dùng',
    headers: {
      id: 'ID',
      name: 'Tên',
      noAccent: 'Không dấu',
      noAbbrev: 'Không viết tắt',
      newWard: 'Phường mới',
      district: 'Quận',
      priceId: 'Price ID',
      group: 'Nhóm',
      shipDis: 'ShipDis',
      price: 'Giá',
      active: 'Trạng thái',
      actions: 'Thao tác',
    },
    fields: {
      name: 'Tên',
      nameNoAccent: 'Tên (không dấu)',
      nameNoAbbrev: 'Tên (không viết tắt)',
      newWard: 'Phường mới',
      districtHint: 'Quận: {district} (sửa ở tab Phường mới)',
      editNewWard: 'Sửa Phường mới (Quận / ShipDis)',
      editNewWardTitle: 'Quận và ShipDis thuộc về Phường mới — mở Phường mới này để sửa',
      districtPriceId: 'District Price ID',
      group: 'Nhóm',
      shipDis: 'ShipDis',
      mapDistrict: 'Map District',
      price: 'Giá',
      subDistricts: 'Có quận con',
      wardList: 'Danh sách phường',
      shipLocCount: 'Ship Loc Count',
      district: 'Quận',
    },
  },
}
